import { path } from 'ramda'

const mockTranslations = {
  en: { hi: 'hello', world: 'world', views: { global: { search: 'Search' } } },
  es: { hi: 'hola', world: 'mundo', views: { global: { search: 'Buscar' } } },
}

export default class I18nMock {
  constructor({ translations = mockTranslations, locale = 'en' }) {
    this.translations = translations
    this.locale = locale
  }
  t(scope, options = {}) {
    return (
      path([this.locale, ...scope.split('.')], this.translations) ||
      options.defaultValue ||
      `translation for '${scope}' missing`
    )
  }
  l(date) {
    return date
  }
}
